const LOADING_PREFIX = 'message.constants.messages.';
export const LOADING_DEFAULT = LOADING_PREFIX + 'loading';
export const LOADING_PRODUCT = LOADING_PREFIX + 'loadingProduct';
export const LOADING_INSPIRATION = LOADING_PREFIX + 'loadingInspiration';
export const LOADING_SIZES = LOADING_PREFIX + 'loadingSizes';
export const LOADING_SUGGESTED_SIZES = LOADING_PREFIX + 'loadingSuggestedSizes';
export const LOADING_SIZE = LOADING_PREFIX + 'loadingSize';
export const LOADING_PROCESSING_IMAGE = LOADING_PREFIX + 'loadingProcessingImage';
export const LOADING_AR_PREVIEW = LOADING_PREFIX + 'loadingARPreview';
export const LOADING_LOGIN = LOADING_PREFIX + 'loadingLogin';
export const LOADING_CART_ADD = LOADING_PREFIX + 'loadingCartAdd';
export const LOADING_CART_UPDATE = LOADING_PREFIX + 'loadingCartUpdate';
export const LOADING_SAVING_REGION = LOADING_PREFIX + 'loadingSavingRegion';
export const LOADING_PET_PORTRAIT_CART_ADD = LOADING_PREFIX + 'loadingPetPortraitCartAdd';
